import { useContext } from 'react'

import { DialpadContext, type DialpadContextValue } from './DialpadProvider'

/**
 * Access the Dialpad dialer state from anywhere inside <DialpadProvider>.
 * Returns null when the provider isn't mounted (non-staff pages).
 */
export function useDialpad(): DialpadContextValue | null {
  return useContext(DialpadContext)
}
